import { Button, Box } from '@chakra-ui/react';
import { TrashIcon } from '../icons';

interface SidebarDeleteButtonProps {
  onClick: (e: React.MouseEvent) => void;
  title: string;
  ariaLabel: string;
  // ホバー/初期表示時の拡大アニメーションを行うか。
  // スクロール領域が狭い widget では拡大がスクロールバーを誘発するため false にする。
  hoverScale?: boolean;
}

export const SidebarDeleteButton = ({
  onClick,
  title,
  ariaLabel,
  hoverScale = true,
}: SidebarDeleteButtonProps) => {
  return (
    <Button
      onClick={onClick}
      title={title}
      aria-label={ariaLabel}
      position="absolute"
      right={2}
      display="flex"
      transform={hoverScale ? 'scale(0.9)' : undefined}
      cursor="pointer"
      alignItems="center"
      justifyContent="center"
      borderRadius="lg"
      border="1px"
      borderColor="gray.200"
      bg="white"
      p={2}
      color="gray.600"
      animation={hoverScale ? 'fadeInScale' : undefined}
      transition="all 0.2s"
      _hover={{
        transform: hoverScale ? 'scale(1.05)' : undefined,
        borderColor: 'gray.300',
        bg: 'gray.100',
        boxShadow: 'md',
      }}
    >
      <Box w={4} h={4}>
        <TrashIcon aria-hidden="true" />
      </Box>
    </Button>
  );
};
